import { FC } from 'react';
import { Typography } from '@mui/material';
import { useGetMyCompanyQuery } from '../../shared/redux/rental';

export const Company: FC = () => {
  const { data: company, isFetching } = useGetMyCompanyQuery();

  if (isFetching) {
    return (
      <Typography
        sx={{
          color: '#dedede',
          fontWeight: 'bold',
          fontSize: '16px',
          whiteSpace: 'nowrap',
        }}
      >
        Laster...
      </Typography>
    );
  }

  return (
    <Typography
      sx={{
        color: '#dedede',
        fontWeight: 'bold',
        fontSize: '16px',
        whiteSpace: 'nowrap',
      }}
    >
      {company?.name || '(Mangler firma)'}
    </Typography>
  );
};
